import { ActionButton } from '@/common/buttons/ActionButton';
import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { ExportList } from '@/common/entities/export/ExportList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ChainList } from '@/skdr/entities/job/ChainList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect } from 'react';
import { McdInvClaimPymtList } from '../mcdInvClaimPymt/McdInvClaimPymtList';
import { ClaimList } from './ClaimList';

export const PymtDetail = () => {
  const { entityObj } = useEntityMgr();

  const rsrc = useRsrc();

  /**
   * This code is not good. Please do not copy this. Particularly, the many if statements are not good,
   * and the insertion of claimIds into the entityObj is also not a good pattern.
   *
   * TODO: refactor
   */
  useEffect(() => {
    const claimType = entityObj.claimType;
    if (claimType === undefined) {
      return;
    }

    if (claimType === 'MCD') {
      rsrc
        .rows('sc', 'MCD_INV_CLAIM_PYMT', { expr: ExprUtils.whereParams('pymtId', entityObj.id) })
        .then((invClaimPymts) => {
          const claimIds = invClaimPymts.map((invClaimPymt) => invClaimPymt.mcdClaimId);
          entityObj.claimIds = claimIds;
        });
    } else if (claimType === 'CHBK') {
      rsrc
        .rows('sc', 'INDIR_SALE_CHBK_CLAIM_PYMT', { expr: ExprUtils.whereParams('pymtId', entityObj.id) })
        .then((saleClaimPymts) => {
          const claimIds = saleClaimPymts.map((saleClaimPymt) => saleClaimPymt.chbkClaimId);
          entityObj.claimIds = claimIds;
        });
    } else {
      rsrc.rows('sc', 'INCTV_CLAIM', { expr: ExprUtils.whereParams('pymtId', entityObj.id) }).then((claims) => {
        const claimIds = claims.map((claim) => claim.id);
        entityObj.claimIds = claimIds;
      });
    }
  }, [entityObj.claimType]);

  // Once PymtDetail is refactored into separate components per claimType, this will not be necessary
  const secondTab =
    entityObj.claimType === 'MCD' ?
      { id: 'Invoices and Claims', label: 'Invoices & Claims', content: <McdInvClaimPymtList pymtId={entityObj.id} /> }
    : { id: 'claims', label: 'Claims', content: <ClaimList pymtObj={entityObj} /> }; // TODO: discuss if ClaimList should even exist for the other domains

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    secondTab,
    { id: 'export', label: 'Exports', content: <ExportList parentEntity="PYMT" parentEntityId={entityObj.id} /> },
    {
      id: 'approvals',
      label: 'Approvals',
      disabled: !entityObj.apprJobId,
      content: <ChainList jobId={entityObj.apprJobId} />,
    },
    {
      id: 'entityProperties',
      label: 'Entity Properties',
      content: <EntityPropList parentEntity="PYMT" parentEntityObj={entityObj} />,
    },
  ];

  const lifecycleData = {
    title: 'Payment Lifecycle',
    entity: 'PYMT',
    entityId: entityObj.id,
    pluginCode: 'MCD_PYMT_PROC_MGR_ACTION_PLUGIN',
  };

  const augButtons = (buttons) => {
    buttons.push(<ActionButton data={lifecycleData} toolTip="Run Lifecycle" icon={fas.faPlay} />);
  };

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
